// extracted by mini-css-extract-plugin
export default {"warningPrimary":"TFQfT","warningStandard":"FGGJw"};